/*
** Polyfills for modern browsers
*/
import 'intersection-observer'
